import { GetEndorsement, GetEndorsementVariables } from "_graphql/queries/__generated__/GetEndorsement";
import {
  GetEndorsements,
  GetEndorsementsVariables,
} from "_graphql/queries/__generated__/GetEndorsements";
import { GetKEKEndorsements, GetKEKEndorsementsVariables } from "_graphql/queries/kek/__generated__/GetKEKEndorsements";
import { getEndorsement, getOfferEndorsements } from "_graphql/visal/queries/endorsements";

import { getKEKEndorsement, getKEKEndorsements } from "_graphql/kek/queries/offers.kek";
import { useQuery } from "@apollo/client";
import { GetKEKEndorsement, GetKEKEndorsementVariables } from "_graphql/kek/queries/__generated__/GetKEKEndorsement";

export const useEndorsements = (variables: GetEndorsementsVariables) => {
  const { data, ...rest } = useQuery<GetEndorsements, GetEndorsementsVariables>(
    getOfferEndorsements,
    {
      fetchPolicy: "network-only",
      variables,
      notifyOnNetworkStatusChange: true,
    }
  );

  return {
    endorsements: data?.rows || [],
    count: data?.count,
    ...rest,
  };
};

export const useKEKEndorsements = (variables: GetKEKEndorsementsVariables) => {
  const { data, ...rest } = useQuery<GetKEKEndorsements, GetKEKEndorsementsVariables>(
    getKEKEndorsements,
    {
      fetchPolicy: "network-only",
      variables,
      notifyOnNetworkStatusChange: true,
    }
  );

  return {
    endorsements: data?.rows || [],
    count: data?.count || 0,
    ...rest,
  };
};
export const useEndorsement = (variables: GetEndorsementVariables) => {
  const { data, ...rest } = useQuery<GetEndorsement, GetEndorsementVariables>(
    getEndorsement,
    {
      fetchPolicy: "no-cache",
      variables,
      notifyOnNetworkStatusChange: true,
    }
  );

  return {
    endorsement: data?.singleEndorsement,
    ...rest,
  };
};

export const useKEKEndorsement = (variables: GetKEKEndorsementVariables) => {
  const { data, ...rest } = useQuery<GetKEKEndorsement, GetKEKEndorsementVariables>(
    getKEKEndorsement,
    {
      fetchPolicy: "no-cache",
      variables,
      notifyOnNetworkStatusChange: true,
    }
  );

  return {
    endorsement: data?.singleEndorsement,
    ...rest,
  };
};
